module.exports = __webpack_public_path__ + "img/insurance_policy.3b4dfb07.png";